import React, { Component, PropTypes  } from 'react'
import { connect } from 'react-redux'
import Layout from '../components/componentKit2/Layout'
import { fetchChat,
  PRIVATE_CHAT_ID,
  fetchTaskDayIfNeeded,
  setTypeId,
  setMenuList,
  clearRenderChat} from '../actions'

import Chat from './Chat'
import CSSModules from 'react-css-modules'
import styles from './chatPage.css'
import Loader from '../components/componentKit/Loader'

/**
 *  Контейнер ChatPage.
 *  Используется для отображения страницы Чата (/chats)
 *
 */
class ChatPage extends Component {
  /**
   * @memberof ChatPage
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {func} propTypes.clearRenderChat Очистка чата
   * @prop {func} propTypes.setMenuList установка выбранной старницы в меню
   * @prop {func} propTypes.fetchTaskDayIfNeeded Получение данных для страницы дня
   * @prop {object} propTypes.userInfo Данные пользователя
   *
   * */
  static propTypes = {
    clearRenderChat: PropTypes.func.isRequired,
    /**
     * Функция Очистка чата
     * @memberof ChatPage
     * @param {number} page - Номер выбранной страницы
     */
    setMenuList: PropTypes.func.isRequired,
    /**
     * Функция Очистка чата
     * @memberof ChatPage
     * @param {string} day - Номер дня.
     */
    fetchTaskDayIfNeeded: PropTypes.func.isRequired,
    userInfo: PropTypes.object.isRequired,
  }
  componentDidMount() {

    const { fetchTaskDayIfNeeded, selectedTaskDay, taskDayData, setTypeId, setMenuList, clearRenderChat } = this.props
    setMenuList(5)
    fetchTaskDayIfNeeded(selectedTaskDay)
    //clearRenderChat()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedTaskDay !== this.props.selectedTaskDay) {

      const { fetchTaskDayIfNeeded, selectedTaskDay} = nextProps
      fetchTaskDayIfNeeded(selectedTaskDay)
    }
  }
// //<LoadingView title="Если вы видите это окно, значит мы делаем личный кабинет для вас удобнее! Напишите нам в чат
// тех подержки (внизу справа) или на почту sb@todayme.ru" taskBack={true}/>

  render() {
    const {taskDay, taskDayData, userInfo, selectedDayId} = this.props
   // const { isFetching, isLoad, dayData } = taskDayData
    const { role } = userInfo.data
    console.log('chatPageeee-------')
    console.log(this.props)

    return (
    <Layout pageNumber={5} prevSeasons={userInfo.data.prevSeasons}>
      { taskDay && taskDay.data && taskDay.data.length !== 0 ?
              <Chat
                userId={taskDay.data[0].user.id}
                isWindow={false}
                showAdminPanel={false}
                isOpen={true}
                isTaskChat={true}
                role={role}
                user={taskDay.data[0].user}
            /*    taskDay={taskDay.data[0]}*/
              /> : <Loader /> }
    </Layout>
    )
  }
}

const mapStateToProps = state => {

  const { selectedReports, selectedDayId, chats, recivedReports, selectedTaskDay, recivedTaskDay, userInfo, taskDayData } = state

  const {
    isFetching,
    reports
    } = recivedReports[selectedReports] || {
    isFetching: true,
    reports: []
  }
  const {taskDay} = recivedTaskDay[selectedTaskDay] || {
    isFetching: true,
    taskDay: {}
  }

  return {
    taskDay,
    userInfo,
    chats,
    recivedTaskDay,
    selectedTaskDay,
      selectedDayId,
    selectedReports,
    isFetching,
    taskDayData,
    reports
  }
}


ChatPage = connect(
  mapStateToProps,
  {
    fetchTaskDayIfNeeded,
    setTypeId,
    clearRenderChat,
    fetchChat,
    setMenuList
  }

)(ChatPage)

export default CSSModules(ChatPage, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/containers/ChatPage.js